<template>
  <v-container
    id="validacao-baixas-historico"
    fluid
    tag="section"
  >
    <v-row>
      <v-col cols="12">
        <base-material-card
          color="primary"
          icon="mdi-file-compare"
          inline
          class="ml-0 px-5 py-4"
        >
          <template v-slot:after-heading>
            <div class="display-2 font-weight-light">
              Validação de Baixas
            </div>
          </template>

          <v-btn
            id="btn-nova-validacao-baixas"
            color="success"
            dark
            elevation="1"
            class="mt-5"
            style="float:left"
            relative
            text
            medium
            @click="$router.push(`edit`)"
          >
            <v-icon
              left
              size="30px"
            >
              mdi-plus-circle
            </v-icon>
            Nova Validação de Baixas
          </v-btn>

          <v-text-field
            id="validacao-baixas-historico-search"
            v-model="search"
            append-icon="mdi-magnify"
            class="break-search bs-validacao-baixas ml-auto mt-4"
            label="Procurar"
            hide-details
            single-line
            style="max-width: 250px;"
          />

          <general-progress-bars
            class="mt-11"
            :items="downloadProgressData"
            prefix-text="Baixando Validação de Baixas"
          />

          <v-divider class="mt-10" />

          <v-data-table
            class="validacao-baixas-table"
            :headers="headers"
            :items="validacoes"
            :search.sync="search"
            :header-props="{
              sortByText: 'Ordenar Por'
            }"
            :footer-props="{
              itemsPerPageText: 'Itens por Página'
            }"
            no-data-text="Nenhuma Validação de Baixas disponível"
            no-results-text="Nenhum registro correspondente encontrado"
            mobile-breakpoint="800"
          >
            <template v-slot:[`item.id`]="{ item }">
              {{ item.id }}
            </template>
            <template v-slot:[`item.nome`]="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <div
                    class="text-truncate-column"
                    v-bind="attrs"
                    v-on="on"
                  >
                    {{ item.nome }}
                  </div>
                </template>
                <span>{{ item.nome }}</span>
              </v-tooltip>
            </template>
            <template v-slot:[`item.usuario`]="{ item }">
              {{ item.usuario }}
            </template>
            <template v-slot:[`item.executed`]="{ item }">
              {{ item.executed }}
            </template>
            <template v-slot:[`item.status`]="{ item }">
              <general-status :status="item.status" />
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <v-btn
                id="action-download-validacao-baixas"
                :class="item.status != 'SUCESSO' ? 'cursor-block' : ''"
                :disabled="item.status != 'SUCESSO'"
                color="gray"
                min-width="0"
                class="px-1"
                fab
                icon
                x-small
                :loading="
                  downloadProgressData[item.id] !== undefined ? true : false
                "
                @click="downloadItem(item)"
              >
                <v-icon small>
                  mdi-download
                </v-icon>
              </v-btn>
              <v-menu 
                v-if="item.status == 'SUCESSO' || canRunItem(item) || canDeleteItem(item)"
                offset-y
                right
              >
                <template 
                  v-slot:activator="{ on, attrs }"
                >
                  <v-btn
                    id="action-more-validacao-baixas"
                    color="white"
                    class="ml-1"
                    height="22px"
                    width="22px"
                    fab
                    x-small
                    elevation="1"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon small>
                      mdi-dots-vertical
                    </v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    v-if="canRunItem(item)"
                    @click="executarValidacaoBaixas(item.id)"
                  >
                    <v-list-item-icon class="mx-0 my-0 py-4">
                      <v-icon small>
                        mdi-play
                      </v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>
                      Executar
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-if="canDeleteItem(item)"
                    @click="openDeleteDialog(item)"
                  >
                    <v-list-item-icon class="mx-0 my-0 py-4">
                      <v-icon small>
                        mdi-trash-can-outline
                      </v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>
                      Deletar
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    @click="openDialogDetalhes(item)"
                  >
                    <v-list-item-icon class="mx-0 my-0 py-4">
                      <v-icon small>
                        mdi-file-find-outline
                      </v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>
                      Detalhes
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
            <template v-slot:[`footer`]>
              <v-switch
                v-if="$store.getters.userIsAdmin"
                class="pa-0 pl-2 swithInterna"
                style="position: absolute" 
                color="primary"
                label="Exibir Expirados"
                dense
                @change="processamentosExpirados = $event, getAllValidacoes()"
              />
            </template>
          </v-data-table>
        </base-material-card>

        <dialog-delete
          :show-dialog="dialogDelete"
          @changeValue="dialogDelete = $event"
          @deleteTriggered="deletarValidacaoBaixas(dialogDeleteData.id)"
        >
          <template slot="title">
            Deletar Validação de Baixas #{{ dialogDeleteData.id }}
          </template>
          <template slot="body">
            Tem certeza que deseja deletar <strong>{{ dialogDeleteData.nome }}</strong>? 
          </template>
        </dialog-delete>
      </v-col>
    </v-row>

    <general-dialog-detalhes
      ref="dialogDetalhes"
      title="Detalhes"
      :show-dialog="dialogDetalhes"
      @changeValue="dialogDetalhes = $event"
    >
      <template slot="body">
        <v-data-table
          :headers="dialogDetalhesHeader"
          :items="dialogDetalhesData"
          hide-default-footer
          class="elevation-1 style-table-dialog-detalhes"
          disable-pagination
          mobile-breakpoint="10"
        />
      </template>
    </general-dialog-detalhes>
  </v-container>
</template>

<script>
import ValidacaoBaixasService from '@/services/ValidacaoBaixasService';
import powerupsActionsMixins from '@/mixins/powerupsActionsMixins.js';
import DateFormatterMixins from '@/mixins/dateFormatterMixins.js';
import pusherMixins from '@/mixins/pusherMixins';
import tourMixins from '@/mixins/tourMixins';
import dayjs from 'dayjs';

export default {

  components: {
    DialogDelete: () => import('@/components/general/DialogDelete'),
    GeneralProgressBars: () => import('@/components/general/GeneralProgressBars.vue'),
    GeneralStatus: () => import('@/components/general/GeneralStatus.vue'),
    GeneralDialogDetalhes: () => import('@/components/general/GeneralDialogDetalhes')
  },
  
  mixins: [powerupsActionsMixins, DateFormatterMixins, pusherMixins, tourMixins],

  data() {
    return {
      processamentosExpirados: false,
      powerupService: ValidacaoBaixasService,
      powerupEntityName: 'Validacao_Baixas',
      arrTour: [
        {
          element: '#btn-nova-validacao-baixas',
          intro: 'Clicando neste botão você poderá criar novos relatórios de Validação de Baixas.',
          scrollTo: 'tooltip',
          position: 'right'
        },
        {
          element: '#validacao-baixas-historico-search',
          intro: 'Neste campo você poderá pesquisar por relatórios de Validação de Baixas já existentes.',
          scrollTo: 'tooltip',
          position: 'bottom'
        },
        {
          element: '#action-download-validacao-baixas',
          intro: 'Clicando neste ícone você poderá fazer o download em .XLSX do resultado de seu relatório de Validação de Baixas.',
          scrollTo: 'tooltip',
          position: 'left'
        },
        {
          element: '#action-more-validacao-baixas',
          intro: 'Aqui você acessa outras opções para seu relatório de Validação de Baixas, como executá-lo novamente ou deletá-lo.',
          scrollTo: 'tooltip',
          position: 'left'
        }
      ],
      headers: [
        {
          text: '#',
          value: 'id'
        },
        {
          text: 'Nome',
          value: 'nome'
        },
        {
          text: 'Usuário',
          value: 'usuario'
        },
        {
          text: 'Executado',
          value: 'executed'
        },
        {
          text: 'Status',
          value: 'status'
        },
        {
          sortable: false,
          text: 'Ações',
          value: 'actions',
          class: 'pl-4'
        }
      ],
      validacoes: [],
      search: '',
      dialogDelete: false,
      dialogDeleteData: { id: undefined, nome: undefined },
      downloadProgressData: {}
    };
  },

  computed: {
    user() {
      return this.$store.getters.getUser;
    }
  },

  mounted() {
    this.getAllValidacoes();
    this.subscribe();
  },

  methods: {
    subscribe() {
      this.pusherChannel.bind('refreshValidacaoBaixas', () => {
        this.getAllValidacoes();
      });
    },

    getAllValidacoes() {

      ValidacaoBaixasService.getValidacoes(this.processamentosExpirados)
        .then(response => {
          this.validacoes = [];

          response.data.validacoes.forEach(val => {
            this.validacoes.push({
              id: val.id,
              nome: val.nome,
              usuario: val.usuario.nome,
              usuario_id: val.usuario.id,
              executed: val.executado_em
                ? dayjs(val.executado_em).format('DD/MM/YYYY HH:mm')
                : '-',
              status: val.status,
              dataBaseInicio: val.data_base_inicio ?? '-',
              dataBaseFim: val.data_base_fim ?? '-'
            });
          });
        })
        .catch(err => {
          console.log('Erro: ', err);
          this.$toast.error('Erro ao carregar relatórios de Validação de Baixas.', '', { position: 'topRight' });
        })
        .finally(()=>{
          this.iniciarTourPagina();
        });
    },

    iniciarTourPagina() {
      if (this.tourFuncCalled) return;
      let arrTourFormatted = this.validacoes.length ? this.arrTour : this.arrTour.splice(0, 2);
      this.iniciarTour(arrTourFormatted);
    },

    openDeleteDialog(validacao) {
      
      this.dialogDeleteData = {
        id: validacao.id,
        nome: validacao.nome
      };

      this.dialogDelete = true;
    },

    deletarValidacaoBaixas(id) {
      
      this.dialogDelete = false;
      
      ValidacaoBaixasService.excluirValidacaoBaixas(id)
        .then(() => {
          this.getAllValidacoes();
          this.$toast.success('Validação de Baixas excluída com sucesso.', '', { position: 'topRight' });
        })
        .catch(err => {
          this.$toast.error('Erro ao excluir Validação de Baixas.', '', { position: 'topRight' });
          console.log('Erro: ', err);
        });
    },

    executarValidacaoBaixas(id) {
      
      ValidacaoBaixasService.executarValidacaoBaixas(id)
        .then(() => {
          this.$toast.info('Sua planilha será gerada em instantes. Por favor, aguarde.', '', { position: 'topRight', timeout: 2000 });
          this.getAllValidacoes();
        })
        .catch(err => {
          this.$toast.error('Erro ao executar Validação de Baixas.', '', { position: 'topRight' });
          console.log('Erro: ', err);
        });
    },

    openDialogDetalhes(validacao) {
      
      this.dialogDetalhesData = [
        {
          parametro: 'NOME:',
          valor: validacao.nome
        },
        {
          parametro: 'DATA BASE DE:',
          valor: this.formatDate(validacao.dataBaseInicio)
        },
        {
          parametro: 'DATA BASE ATÉ:',
          valor: this.formatDate(validacao.dataBaseFim)
        }
      ];

      this.dialogDetalhes = true;
    }
  }
};
</script>

<style>

@media screen and (min-width: 800px) {
  .validacao-baixas-table table tr td:nth-child(2) {
    max-width: 200px;
  }

  .validacao-baixas-table table tr td:nth-child(7),
  .validacao-baixas-table table tr td:nth-child(8) {
    white-space: nowrap !important;
  }
}

@media screen and (max-width: 480px) {
  .bs-validacao-baixas {
    width: 235.86px !important;
  }
}

.swithInterna label {
  font-size: 13px !important;
  margin-left: 0px !important;
}

</style>